export const PRODUCT_SELECTOR = {
    URL: 'https://www.masterlock.com/product/selector/safe',
    TEXT: 'Product Selector'
}


// WEBPACK FOOTER //
// ./src/constants/app.js